import { Shareholding, ShareholdingType } from '@commenda/api';
import { OwnershipRelationshipType } from '@prisma/client';
import { OTHERS_STAKEHOLDER_ID } from '../constants';

export const buildDisplayRows = (
  shareholdings: Shareholding[],
  totalOwnershipPercentScaled: number,
  percentScale: number,
): Shareholding[] => {
  const fullScaled = 100 * percentScale;
  const othersScaled = fullScaled - totalOwnershipPercentScaled;
  if (othersScaled <= 0) return shareholdings;

  const othersRow: Shareholding = {
    stakeholdingId: OTHERS_STAKEHOLDER_ID,
    directorId: null,
    name: 'All other shareholders',
    type: ShareholdingType.INDIVIDUAL,
    ownershipPercent: othersScaled,
    // Display column reads diluted; "Others" carries the unallocated diluted total.
    dilutedOwnershipPercent: othersScaled,
    nationality: null,
    relationshipType: OwnershipRelationshipType.OTHER,
    hasSignificantControl: false,
    controlType: null,
    incorporationCountry: null,
    stakeholderCorporationId: null,
    stockClass: null,
  };
  return [...shareholdings, othersRow];
};
